import VInput from './VInput';
export { VInput };
export default VInput;
//# sourceMappingURL=index.js.map